import React, { useEffect, useState } from 'react';
import { Switch } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectEditBillingShiftDifferentialRows,
  selectEditPayrollShiftDifferentialRows,
  selectIsEditMod,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { Controller, useFormContext } from 'react-hook-form';
import { shiftDifferentialModStyles } from '../ShiftDifferentialMod.style';
import { findIndex, findRow } from '../Utils';
import { modsEnums } from 'app/models/Placement/PlacementMods';
import { missingField } from 'app/constants';

interface GridCellProps {
  [key: string]: any;
}

export const EditSelectAllCell = (props: any) => {
  return (
    <>
      <EditSelectAll cellParams={props?.cellParams} currentMod={props?.currentMod} />
    </>
  );
};

const EditSelectAll = React.memo(function EditSelectAll(params: GridCellProps) {
  const dispatch = useDispatch();
  const currentValue = params?.cellParams?.value;
  const [selectAllValue, setSelectAllValue] = useState(currentValue === missingField ? null : currentValue);
  const { control } = useFormContext();
  const { classes } = shiftDifferentialModStyles({ isModEdit: false });
  const isModEdit = useSelector(selectIsEditMod);
  const shiftDiffEditRequests =
    params?.currentMod === modsEnums.PayrollShiftDifferential
      ? useSelector(selectEditPayrollShiftDifferentialRows)
      : useSelector(selectEditBillingShiftDifferentialRows);

  const rowId = params?.cellParams?.id;

  useEffect(() => {
    const newValue = params?.cellParams?.row?.selectAll;
    setSelectAllValue(newValue);
  }, [params.cellParams.row.sunday, params.cellParams.row.monday, params.cellParams.row.tuesday, params.cellParams.row.wednesday, params.cellParams.row.thursday, params.cellParams.row.friday, params.cellParams.row.saturday]);

  const setSelectAllForEdit = data => {
    let newRow = shiftDiffEditRequests.slice(0);
    const shiftDiffEditRow = findRow(params, shiftDiffEditRequests, rowId);
    const updatedCell = {
      ...shiftDiffEditRow,
      selectAll: data.checked ? 'Yes' : 'No',
      monday: data.checked,
      tuesday: data.checked,
      wednesday: data.checked,
      thursday: data.checked,
      friday: data.checked,
      saturday: data.checked,
      sunday: data.checked,
    };
    const editDateIndex = findIndex(updatedCell, params, shiftDiffEditRequests, rowId);
    newRow[editDateIndex] = updatedCell;
    switch (params?.currentMod) {
      case modsEnums.PayrollShiftDifferential: {
        dispatch(placementModsAction.setEditPayrollShiftDiffRows(newRow));
        break;
      }
      case modsEnums.BillingShiftDifferential: {
        dispatch(placementModsAction.setEditBillingShiftDiffRows(newRow));
        break;
      }
    }
    dispatch(placementModsAction.setCustomTemplateType(true));
    dispatch(placementModsAction.setOriginCustomTemplateChanged(true));
  };

  return (
    <>
      <Controller
        name={`shiftDiffRequests${rowId}.selectAll}`}
        control={control}
        render={({ field: { onChange, onBlur, value, ...rest } }) => (
          <Switch
            checked={selectAllValue === 'Yes'}
            className={isModEdit ? classes.switchPrimary :classes.switchLightBlue}
            value={selectAllValue}
            onChange={e => {
              onChange(e.target.checked ? 'Yes' : 'No');
              setSelectAllValue(e.target.checked ? 'Yes' : 'No');
              setSelectAllForEdit(e.target);
            }}
            {...rest}
          />
        )}
      />
      {selectAllValue}
    </>
  );
});

